import React from 'react';
import { PageWrapper } from '../../components/common';
import ListadoCeldasComponent from '../../components/balanza/ListadoCeldas';

const ListadoCeldas: React.FC = () => {
  return (
    <PageWrapper>
      <ListadoCeldasComponent />
    </PageWrapper>
  );
};

export default ListadoCeldas;